export const removeItem = {
  data () {
    return {
      items: []
    }
  },
  methods: {
    remove (index) {
      this.items.splice(index, 1)
    },
    removeById (id) {
      this.items = this.items.filter((item) => {
        return (item.id !== id)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/removeItem.js